import {
  RECEIVE_CHANGE_SHIPPING_ADDRESS_ERROR,
  RECEIVE_SHIPPING_INFO,
  RECEIVE_SHIPPING_INFO_BY_ID,
  REQUEST_SHIPPING_INFO,
  RESET_SHIPPING_FORM,
  UPDATE_MAILING_ADDRESS_OR_NAME,
  UPDATE_SHIPPING_PHONE
} from 'constants/reduxActions';

import { err, setError } from 'actions/errors';
import { catchHandlerFactory } from 'actions/checkout/purchase';
import { redirectTo } from 'actions/redirect';
import { addresses, changeAddress, deleteAddress } from 'apis/mafia';
import {
  fetchApiNotAuthenticatedMiddleware,
  fetchErrorMiddleware,
  fetchMafiaValidationErrorMiddleware
} from 'middleware/fetchErrorMiddleware';
import { prependAppRoot } from 'history/AppRootUtils';
import { setSessionCookies } from 'actions/session';
import { processHeadersMiddleware } from 'middleware/processHeadersMiddlewareFactory';

export function requestShippingInfo() {
  return {
    type: REQUEST_SHIPPING_INFO
  };
}

export function receiveShippingInfo(addresses) {
  return {
    type: RECEIVE_SHIPPING_INFO,
    addresses
  };
}

export function receiveShippingInfoById(address) {
  return {
    type: RECEIVE_SHIPPING_INFO_BY_ID,
    address
  };
}

export function updateMailingAddressOrName({ name, value, suggestedAddress }) {
  return {
    type: UPDATE_MAILING_ADDRESS_OR_NAME,
    name,
    value,
    suggestedAddress
  };
}

export function updateShippingPhone({ name, value }) {
  return {
    type: UPDATE_SHIPPING_PHONE,
    name,
    value
  };
}

export function resetShippingForm() {
  return {
    type: RESET_SHIPPING_FORM
  };
}

export function receiveChangeShippingAddressError(error) {
  return {
    type: RECEIVE_CHANGE_SHIPPING_ADDRESS_ERROR,
    error
  };
}

export function fetchShippingInfo(addressId, returnTo, getAddresses = addresses) {
  return function (dispatch, getState) {
    dispatch(requestShippingInfo());
    const { cookies, environmentConfig: { api: { mafia } }, routing: { locationBeforeTransitions } } = getState();
    return getAddresses(mafia, cookies)
      .then(processHeadersMiddleware(setSessionCookies(dispatch)))
      .then(fetchApiNotAuthenticatedMiddleware)
      .then(fetchErrorMiddleware)
      .then(resp => {
        const { addresses } = resp;
        if (addressId) {
          const address = addresses.find(address => address.addressId === addressId);
          if (address) {
            dispatch(receiveShippingInfoById(address));
          } else {
            dispatch(setError(err.GENERIC, new Error('Address not found...')));
          }
        } else { // called from changeShippingAddress()
          dispatch(receiveShippingInfo(addresses));
          dispatch(redirectTo(prependAppRoot(returnTo || '/addresses', locationBeforeTransitions)));
        }
      })
      .catch(catchHandlerFactory(dispatch, prependAppRoot(returnTo || '/addresses', locationBeforeTransitions)));
  };
}

export function deleteShippingAddress(addressId) {
  return function (dispatch, getState) {
    const { environmentConfig: { api: { mafia } }, routing: { locationBeforeTransitions } } = getState();
    return deleteAddress(mafia, addressId)
      .then(processHeadersMiddleware(setSessionCookies(dispatch)))
      .then(fetchApiNotAuthenticatedMiddleware)
      .then(fetchErrorMiddleware)
      .then(resp => {
        dispatch(fetchShippingInfo());
        return resp;
      })
      .catch(catchHandlerFactory(dispatch, prependAppRoot('/addresses', locationBeforeTransitions)));
  };
}

// For SimpleReturns snail mail form
export function getNewAddressId(address, cb, { forceOriginal = false, saveInvalidAddress = true }) {
  return function (dispatch, getState) {
    const { cookies, environmentConfig: { api: { mafia } } } = getState();
    return changeAddress({ mafia, address, forceOriginal }, cookies, saveInvalidAddress)
      .then(processHeadersMiddleware(setSessionCookies(dispatch)))
      .then(fetchApiNotAuthenticatedMiddleware)
      .then(fetchMafiaValidationErrorMiddleware)
      .then(fetchErrorMiddleware)
      .then(resp => {
        const { valid, invalidFields } = resp;
        if (!valid && invalidFields?.length) {
          dispatch(receiveChangeShippingAddressError({ extraInformation: invalidFields }));
        } else {
          cb(resp);
        }
        return resp;
      })
      .catch(e => {
        dispatch(receiveChangeShippingAddressError(e));
      });
  };
}

export function changeShippingAddress(address, returnTo) {
  return function (dispatch, getState) {
    dispatch(requestShippingInfo());
    const { cookies, environmentConfig: { api: { mafia } } } = getState();
    return changeAddress({ mafia, address }, cookies)
      .then(processHeadersMiddleware(setSessionCookies(dispatch)))
      .then(fetchApiNotAuthenticatedMiddleware)
      .then(fetchMafiaValidationErrorMiddleware)
      .then(fetchErrorMiddleware)
      .then(resp => {
        const { valid, invalidFields } = resp;
        if (!valid && invalidFields?.length) {
          dispatch(receiveChangeShippingAddressError({ extraInformation: invalidFields }));
        } else { // return to /addresses
          dispatch(fetchShippingInfo('', returnTo));
        }
        return resp;
      })
      .catch(e => {
        dispatch(receiveChangeShippingAddressError(e));
      });
  };
}
